<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<form id="resetPasswordForm" [formGroup]="dataForm" (ngSubmit)="onSubmitResetPassword()" novalidate>
	<h3>Reset Password</h3>

	<div class="flex-layout-row flex-layout-gap-10px buttonstrip-padding">
		<button class="submitBtn" mat-raised-button type="submit" color="primary">Reset</button>
		<!--<button mat-raised-button (click)="save()" color="primary">Create</button>-->
		<button mat-raised-button (click)="onCancel($event)">Cancel</button>
	</div>

	<div class="flex-layout-column flex-layout-gap-30px">
		<div>
			<mat-form-field>
				<mat-label>Password</mat-label>
				<input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput autocomplete="new-password" (change)="passwordFieldChanged()"/>
				<button mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
					<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
				</button>
				<mat-error *ngIf="password.touched && password.errors?.required">
					Password is required
				</mat-error>
				<mat-error *ngIf="password.touched && (password.errors?.pattern || password.errors?.minlength) && !password.errors?.maxlength">
					Password must be at least 8 characters, including a number and a special character
				</mat-error>
				<mat-error *ngIf="password.touched && password.errors?.maxlength">
					Password must be no more than 12 characters
				</mat-error>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label>Confirm Password</mat-label>
				<input [type]="hidePassword ? 'password' : 'text'" formControlName="confirmPassword" matInput />
				<mat-error *ngIf="confirmPassword.touched && confirmPassword.errors?.required">
					Confirm Password is required
				</mat-error>
				<mat-error *ngIf="confirmPassword.errors?.passwordMismatch && !confirmPassword.errors?.maxlength">
					Confirm Password must match Password
				</mat-error>
				<mat-error *ngIf="confirmPassword.touched && confirmPassword.errors?.maxlength">
					Confirm Password must be no more than 12 characters
				</mat-error>
			</mat-form-field>
		</div>

	</div>

</form>
